"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagKG = function FlagKG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.5,33.24S72.43,30.89,62,22.25c-3.08-2.55-7.54-4.49-11.89-5.93A44.89,44.89,0,0,1,60.83,17c14.5,2.94,28.57-4.1,28.57-4.1S75.21,14.29,62.88,8.69A35.82,35.82,0,0,0,51,6.16a42.57,42.57,0,0,1,9.44-1.73C75.22,3.6,87.05-6.75,87.05-6.75s-13.37,5-26.71,2.65c-3.88-.68-8.65-.17-13.09.72A44.07,44.07,0,0,1,56.72-8c14-4.65,22.77-17.74,22.77-17.74S67.88-17.49,54.4-16.24c-4,.37-8.56,2.17-12.68,4.24a44.27,44.27,0,0,1,8.08-7.17c12.33-8.19,17.3-23.11,17.3-23.11s-9,11.05-21.7,15.8a36.21,36.21,0,0,0-10.25,6.69,42.61,42.61,0,0,1,5.49-8c9.86-11,10.89-26.73,10.89-26.73s-5.93,13-17,20.77c-3.23,2.27-6.25,6-8.75,9.79a43.89,43.89,0,0,1,3.4-10c6.64-13.23,3.54-28.65,3.54-28.65s-2.35,14.07-11,24.49c-2.55,3.07-4.5,7.54-5.94,11.88a45.34,45.34,0,0,1,.65-10.7c2.94-14.5-4.1-28.57-4.1-28.57S13.78-51.31,8.18-39A35.87,35.87,0,0,0,5.64-27.11a43.55,43.55,0,0,1-1.73-9.43C3.09-51.32-7.27-63.15-7.27-63.15s5,13.37,2.65,26.71c-.67,3.88-.17,8.65.72,13.09a44.5,44.5,0,0,1-4.64-9.47c-4.65-14-17.75-22.77-17.75-22.77S-18-44-16.75-30.5c.37,4,2.16,8.57,4.24,12.68a44.27,44.27,0,0,1-7.17-8.08c-8.19-12.34-23.11-17.3-23.11-17.3s11.05,9,15.8,21.7c1.29,3.46,3.89,7,6.69,10.25a42.76,42.76,0,0,1-8-5.49C-39.33-26.6-55-27.64-55-27.64s13,5.94,20.77,17c2.27,3.22,6,6.23,9.78,8.74a44.22,44.22,0,0,1-10-3.4C-47.7-11.93-63.11-8.83-63.11-8.83S-49-6.48-38.63,2.16c3.08,2.55,7.54,4.5,11.89,5.94a44.31,44.31,0,0,1-10.7-.66C-51.95,4.51-66,11.55-66,11.55s14.19-1.43,26.51,4.18a36.19,36.19,0,0,0,11.88,2.53A43.64,43.64,0,0,1-37.06,20c-14.77.82-26.61,11.18-26.61,11.18s13.37-5,26.71-2.65c3.89.67,8.66.17,13.1-.72a45.26,45.26,0,0,1-9.47,4.65C-47.38,37.09-56.1,50.18-56.1,50.18S-44.49,41.9-31,40.65c4-.37,8.56-2.17,12.68-4.24a44.76,44.76,0,0,1-8.09,7.18c-12.33,8.18-17.3,23.1-17.3,23.1s9-11,21.7-15.8A36.25,36.25,0,0,0-11.76,44.2a44,44,0,0,1-5.49,8c-9.86,11-10.9,26.72-10.9,26.72s5.94-13,17-20.77c3.23-2.27,6.24-6,8.75-9.78a44.22,44.22,0,0,1-3.4,10C-12.44,71.59-9.34,87-9.34,87S-7,73,1.64,62.52c2.55-3.07,4.5-7.53,6-11.88a44.79,44.79,0,0,1-.66,10.7C4,75.85,11,89.91,11,89.91S9.61,75.72,15.21,63.4a35.93,35.93,0,0,0,2.53-11.88A43,43,0,0,1,19.47,61c.82,14.77,11.18,26.61,11.18,26.61s-5-13.38-2.65-26.71c.68-3.89.17-8.66-.72-13.1a44.77,44.77,0,0,1,4.65,9.47C36.58,71.28,49.67,80,49.67,80s-8.28-11.61-9.53-25.09c-.37-4-2.17-8.56-4.24-12.68a45.05,45.05,0,0,1,7.17,8.09c8.18,12.33,23.11,17.29,23.11,17.29s-11.05-9-15.8-21.7a36.35,36.35,0,0,0-6.69-10.25,43.92,43.92,0,0,1,8,5.49c11,9.87,26.73,10.9,26.73,10.9s-13-5.94-20.77-17c-2.28-3.23-6-6.25-9.79-8.75a44.38,44.38,0,0,1,10,3.4c13.23,6.64,28.65,3.54,28.65,3.54ZM11.78,48A35.86,35.86,0,1,1,47.64,12.18,35.85,35.85,0,0,1,11.78,48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.41-2.33c.77-.59,1.53-1.19,2.3-1.73A49.69,49.69,0,0,0-10.15-8c-.51.55-1,1.15-1.44,1.74a53.42,53.42,0,0,1,12,3.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.61-9.56a50.73,50.73,0,0,1,14,3.8c.93-.55,1.85-1,2.77-1.51A50.36,50.36,0,0,0-6.95-10.93c-.55.46-1.13.88-1.66,1.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.34,7.07c-.71-.68-1.43-1.32-2.16-1.93C.46,11.54-5.41,20.85-8.06,34.37a29.48,29.48,0,0,0,3,2.47c2-13.75,7.66-23.24,14.41-29.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.74,1.12C7.5.51,8.26-.1,9-.65c-.95-.6-1.88-1.12-2.81-1.64-.8.55-1.6,1.08-2.39,1.7C4.8-.06,5.77.5,6.74,1.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.29-.61c5.76,5.06,11,12.18,14.76,22.05a29.61,29.61,0,0,0,1.61-9.26A29.74,29.74,0,0,0,36.58-4.49,46.44,46.44,0,0,0,25.29-.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.56,3.05c.75.55,1.49,1.18,2.22,1.8.74-.62,1.47-1.25,2.22-1.8-.73-.62-1.47-1.22-2.22-1.77C11,1.83,10.3,2.43,9.56,3.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.78-5.61C10.84-5.13,9.91-4.59,9-4c.94.5,1.88,1,2.82,1.61C12.73-3,13.67-3.54,14.6-4c-.94-.55-1.88-1.09-2.82-1.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-11.32,30.92C-8.16,18-2.2,9.17,4.47,3.09q-1.39-1-2.79-1.83c-6.42,5.65-12.22,13.8-15.8,25.55a29.48,29.48,0,0,0,2.8,4.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.73-.61A46.39,46.39,0,0,0-13-4.49,29.75,29.75,0,0,0-18.1,12.18a29.61,29.61,0,0,0,1.61,9.26c3.75-9.87,9-17,14.76-22Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.78-9a51.08,51.08,0,0,1,16.4-3.8,29.68,29.68,0,0,0-32.79,0A51,51,0,0,1,11.78-9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.78,9.59C5.82,16.2.91,25.68-.69,39.26a29.77,29.77,0,0,0,12.47,2.8,29.78,29.78,0,0,0,12.48-2.8C22.66,25.68,17.74,16.2,11.78,9.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.89,1.26Q20.5,2.1,19.1,3.09C25.76,9.17,31.72,18,34.88,30.92a30.44,30.44,0,0,0,2.81-4.11C34.11,15.06,28.3,6.91,21.89,1.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.62,34.37C29,20.85,23.1,11.54,16.39,5.14c-.73.61-1.46,1.25-2.17,1.93,6.76,6.53,12.47,16,14.42,29.77a29.36,29.36,0,0,0,3-2.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.42-7.27c.92.47,1.85,1,2.78,1.51a50.59,50.59,0,0,1,14-3.8c-.52-.49-1.1-.91-1.66-1.37A50.49,50.49,0,0,0,15.42-7.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.82,1.12c1-.62,1.94-1.18,2.91-1.71-.79-.62-1.59-1.15-2.39-1.7-.93.52-1.87,1-2.81,1.64.77.55,1.53,1.16,2.29,1.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.15-2.33a53.58,53.58,0,0,1,12-3.9c-.47-.59-.93-1.19-1.44-1.74A50.09,50.09,0,0,0,20.85-4.06c.77.54,1.54,1.14,2.3,1.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagKG;
exports["default"] = _default;